import { useDispatch, useSelector } from 'react-redux';
import { visualizationSelector } from '../../../../../../store/slices/dashboardSlice/dashboardSlice';
import { useCallback, useState } from 'react';
import { removeVisualization } from '../../../../../../store/slices/dashboardSlice/action';

export const useVisualizationsImage = (id: number) => {
    const [isShowPopup, setIsShowPopup] = useState(false);
    const visualizationEntities = useSelector(visualizationSelector.selectEntities);
    const dispatch = useDispatch();
    const onOpenPopup = () => {
        setIsShowPopup(true);
    };
    const onDeleteImage = useCallback(() => {
        dispatch(removeVisualization(id));
    }, []);

    const onHidePopup = () => {
        setIsShowPopup(false);
    };

    return { visualizationEntities, onDeleteImage, isShowPopup, onOpenPopup, onHidePopup };
};
